import "./BestSellers.scss";

import Slide from "./components/Slide";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getBestsellers } from "../../../services/products";
import { useCookies } from "react-cookie";
import { useTranslation } from "react-i18next";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

export default function BestSellers() {
  const [cookie] = useCookies(["access_token"]);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [bestsellers, setBestsellers] = useState([]);

  useEffect(() => {
    getBestsellers(cookie.access_token).then((res) =>
      setBestsellers(res?.data)
    );
  }, []);

  return (
    <div className="wrap">
      <div className="best-sellers">
        <div className="dots"></div>
        <div className="title-description">
          <div className="title">
            <p>{t("bestsellers")}</p>
          </div>
          <div className="salmon-rectangle"></div>
          <div className="description">{t("best-sellers-description")}</div>
        </div>
        <Swiper
          modules={[Navigation, Pagination, Scrollbar, A11y]}
          scrollbar={{ draggable: true }}
          className="swiper"
          spaceBetween={10}
          slidesPerView={1}
          centeredSlides={false}
          loop={false}
          direction="horizontal"
          observeParents={true}
          parallax={true}
          breakpoints={{
            767: {
              slidesPerView: 1.8,
            },
            1000: {
              slidesPerView: 2.3,
            },
            1200: {
              slidesPerView: 3,
            },
            1350: {
              slidesPerView: 3.5,
            },
            1500: {
              slidesPerView: 4,
            },
            1700: {
              slidesPerView: 4.5,
            },
          }}
          touchEventsTarget="container"
        >
          {bestsellers?.map((bestseller, index) => {
            return (
              <SwiperSlide>
                <Slide
                  key={index}
                  id={bestseller.id}
                  name={bestseller.name}
                  price={bestseller.price}
                  image={
                    bestseller?.images?.length > 0
                      ? bestseller.images[0].url
                      : ""
                  }
                ></Slide>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
      <div className="sticks">
        <img
          src="https://alexfish-static.s3.eu-north-1.amazonaws.com/sushi_sticks.png"
          alt="Суши Sticks"
        />
      </div>
      <div className="banner">
        <div className="text-cta">
          <p className="text">
            SUSHI AT HOME,
            <br />
            <span>SAVOR EVERY BITE,</span>
            <br />
            <span className="delight">PURE DELIGHT!</span>
          </p>
          <button
            onClick={() => {
              localStorage.setItem("activeMenu", 12);
              navigate("/menu/category/12");
            }}
          >
            {t("order-now")}
          </button>
        </div>
        <div className="sushi-at-home">
          <img
            src="https://alexfish-static.s3.eu-north-1.amazonaws.com/sushi-at-home.png"
            alt="Суши"
          ></img>
        </div>
      </div>
    </div>
  );
}
